import { DataSource } from "../pages/document/components/document/document-list-trial2";

export const SET_SELECTED_FOLDER = "SET_SELECTED_FOLDER";
export const REFRESH_FOLDER = "REFRESH_FOLDER";
export const SET_ROOT_FOLDER = "SET_ROOT_FOLDER";
export const SET_DATA_SOURCE = "SET_DATA_SOURCE";

export const setSelectedFolder = (data: any) => {
  return {
    type: SET_SELECTED_FOLDER,
    data,
  };
};

export const setRefreshFolder = (data: any) => {
  return {
    type: REFRESH_FOLDER,
    data,
  };
};

export const setRootFolder = (data: any) => {
  return {
    type: SET_ROOT_FOLDER,
    data,
  };
};

export type DataSourcePayload = {
  data: DataSource[]; 
  listId?: string 
}

export const setDataSource = (data: DataSourcePayload) => {
  return {
    type: SET_DATA_SOURCE,
    data
  }
}